import QueryStatsIcon from '@material-design-icons/svg/filled/query_stats.svg?react';
import ScienceIcon from '@material-design-icons/svg/filled/science.svg?react';
import ViewCarouselIcon from '@material-design-icons/svg/filled/view_carousel.svg?react';

import type { AppSpotlightTabDefinition } from './types';

export const appSpotlightTabs: AppSpotlightTabDefinition[] = [
  { key: 'spotlights', label: 'Spotlights', icon: ViewCarouselIcon },
  { key: 'experiments', label: 'Experiments', icon: ScienceIcon },
  { key: 'reporting', label: 'Reporting', icon: QueryStatsIcon },
];
